import {
  CLEAR_UPDATE_CARD_DETAILS,
  DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_RESET,
  DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_START,
  VERIFY_CARD_SUCCESS,
} from "../actions/ActionConstant";
import { VERIFY_CARD_FAILURE } from "../actions/ActionConstant";
import { VERIFY_CARD_START } from "../actions/ActionConstant";
import {
  FETCH_CARD_DETAILS_START,
  FETCH_CARD_DETAILS_SUCCESS,
  FETCH_CARD_DETAILS_FAILURE,
  DELETE_CARD_START,
  DELETE_CARD_SUCCESS,
  DELETE_CARD_FAILURE,
  SELECT_DEFAULT_CARD_START,
  SELECT_DEFAULT_CARD_SUCCESS,
  SELECT_DEFAULT_CARD_FAILURE,
  ADD_CARD_START,
  ADD_CARD_SUCCESS,
  ADD_CARD_FAILURE,
  GET_CARD_START,
  GET_CARD_SUCCESS,
  GET_CARD_FAILURE,
  UPDATE_CARD_START,
  UPDATE_CARD_SUCCESS,
  UPDATE_CARD_FAILURE,
} from "../actions/ActionConstant";

const initialState = {
  cardDetails: {
    data: {},
    loading: true,
    error: false,
    loadingButtonContent: "",
    buttonDisable: false,
  },
  updateCard: {
    data: {},
    loading: false,
    error: false,
    loadingButtonContent: "",
    buttonDisable: false,
  },
  deleteCard: {
    data: {},
    loading: false,
    error: false,
  },
  selectDefaultCard: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  buttonDisable: false,
  loadingButtonContent: null,
  addCard: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  verifyCard: {
    data: {},
    loading: true,
    success: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  getCardDetails: {
    data: {},
    card_id: null,
    loading: false,
    error: false,
  },
  cardVerificationDocument: {
    cardId: null,
  },
};

const CardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CARD_DETAILS_START:
      return {
        ...state,
        cardDetails: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_CARD_DETAILS_SUCCESS:
      return {
        ...state,
        cardDetails: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_CARD_DETAILS_FAILURE:
      return {
        ...state,
        cardDetails: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case GET_CARD_START:
      return {
        ...state,
        getCardDetails: {
          data: {},
          card_id: action.data,
          loading: true,
          error: false,
        },
      };
    case GET_CARD_SUCCESS:
      return {
        ...state,
        getCardDetails: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case GET_CARD_FAILURE:
      return {
        ...state,
        getCardDetails: {
          data: {},
          loading: false,
          error: action.error,
        },
      };
    case UPDATE_CARD_START:
      return {
        ...state,
        updateCard: {
          data: action.data,
          loading: true,
          error: false,
          loadingButtonContent: "Please wait..",
          buttonDisable: true,
        },
      };
    case UPDATE_CARD_SUCCESS:
      return {
        ...state,
        updateCard: {
          data: action.data,
          loading: false,
          error: false,
          loadingButtonContent: "",
          buttonDisable: false,
        },
      };
    case UPDATE_CARD_FAILURE:
      return {
        ...state,
        updateCard: {
          data: {},
          loading: false,
          error: action.error,
          loadingButtonContent: "",
          buttonDisable: false,
        },
      };
    case DELETE_CARD_START:
      return {
        ...state,
        deleteCard: {
          data: action.data,
          loading: true,
          error: false,
        },
      };
    case DELETE_CARD_SUCCESS:
      return {
        ...state,
        deleteCard: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case DELETE_CARD_FAILURE:
      return {
        ...state,
        deleteCard: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case SELECT_DEFAULT_CARD_START:
      return {
        ...state,
        selectDefaultCard: {
          inputData: action.data,
          loading: true,
          error: false,
          data: {},
        },
      };
    case SELECT_DEFAULT_CARD_SUCCESS:
      return {
        ...state,
        selectDefaultCard: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case SELECT_DEFAULT_CARD_FAILURE:
      return {
        ...state,
        selectDefaultCard: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
        },
      };
    case ADD_CARD_START:
      return {
        ...state,
        addCard: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Please wait..",
          buttonDisable: true,
        },
      };
    case ADD_CARD_SUCCESS:
      return {
        ...state,
        addCard: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case ADD_CARD_FAILURE:
      return {
        ...state,
        addCard: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case VERIFY_CARD_START:
      return {
        ...state,
        verifyCard: {
          data: {},
          loading: true,
          error: false,
          success: false,
          inputData: action.data,
          loadingButtonContent: "Verifying..",
          buttonDisable: true,
        },
      };
    case VERIFY_CARD_SUCCESS:
      return {
        ...state,
        verifyCard: {
          data: action.data,
          loading: false,
          error: false,
          success: true,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case VERIFY_CARD_FAILURE:
      return {
        ...state,
        verifyCard: {
          data: {},
          loading: false,
          error: action.error,
          success: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case CLEAR_UPDATE_CARD_DETAILS: {
      return {
        ...state,
        getCardDetails: {
          data: {},
          card_id: action.data,
          loading: true,
          error: false,
        },
      };
    }
    case DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_START: {
      return {
        ...state,
        cardVerificationDocument: {
          ...state.cardVerificationDocument,
          cardId: action.data,
        },
      };
    }
    case DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_RESET: {
      return {
        ...state,
        cardVerificationDocument: {
          ...state.cardVerificationDocument,
          cardId: null,
        },
      };
    }
    default:
      return state;
  }
};

export default CardsReducer;
